import { determineIutk } from './iutk';
import { name, version } from './pkginfo';
const origin = `${name}-v${version}`;
const setIutk = (body) => {
    const iutk = determineIutk();
    if (iutk) {
        return { iutk, ...body };
    }
    return body;
};
const sendPingback = (body, options) => {
    const pingbackUrl = `https://${options.pingbackHost}/ping`;
    const blob = new Blob([JSON.stringify(setIutk(body))], { type: 'text/plain;charset=UTF-8' });
    let result = false;
    try {
        result = navigator.sendBeacon(pingbackUrl, blob);
    }
    catch (e) {
    }
    return result;
};
export function initMonitor(options) {
    return function monitorTracker(data) {
        if (Array.isArray(data) && data.length === 0) {
            return false;
        }
        const dataArray = Array.isArray(data) ? data : [data];
        const dataArrayWithVersion = dataArray.map(dataItem => ({
            version: '1.0.0',
            ...dataItem,
        }));
        const body = {
            type: 'monitor',
            version: '2.2.0',
            origin,
            data: dataArrayWithVersion,
        };
        return sendPingback(body, options);
    };
}
function getCookieConsentPingbackContent() {
    const storedCookieConsent = document.cookie
        .replace(/(?:(?:^|.*;\s*)CookieConsent\s*=\s*([^;]*).*$)|^.*$/, '$1')
        .toLowerCase();
    if (!storedCookieConsent) {
        return 'absent';
    }
    if (storedCookieConsent.indexOf('preferences:') === -1 ||
        storedCookieConsent.indexOf('statistics:') === -1 ||
        storedCookieConsent.indexOf('marketing:') === -1) {
        return 'invalid';
    }
    return {
        necessary: true,
        preferences: storedCookieConsent.indexOf('preferences:true') > -1,
        statistics: storedCookieConsent.indexOf('statistics:true') > -1,
        marketing: storedCookieConsent.indexOf('marketing:true') > -1,
    };
}
export function initWebsite(options) {
    return function websiteTracker(events, referrer) {
        if (!events || (Array.isArray(events) && events.length === 0)) {
            return false;
        }
        const finalEvents = (Array.isArray(events) ? events : [events])
            .map(each => each.type === 'webpage_load'
            ? {
                ...each,
                type: 'webpage_load_v2',
                cookie_consent: getCookieConsentPingbackContent(),
            }
            : each);
        const finalContext = {
            browser_size: `${window.innerWidth}x${window.innerHeight}`,
            events: finalEvents,
        };
        const body = {
            type: 'website',
            version: '2.2.0',
            origin,
            data: {
                username: document.cookie.replace(/(?:(?:^|.*;\s*)site.model.username\s*=\s*([^;]*).*$)|^.*$/, '$1') || null,
                ui_language: (document.documentElement && document.documentElement.lang) || null,
                location: window.location.href.toString(),
                referrer: referrer || document.referrer || null,
                version: '2.2.2',
                contexts: [finalContext],
            },
        };
        return sendPingback(body, options);
    };
}
export function initStory(options) {
    return function storyTracker(storyId, events, referrer, source) {
        if (!events || (Array.isArray(events) && events.length === 0)) {
            return false;
        }
        const finalContext = {
            story_id: storyId,
            source: source || 'web',
            events: Array.isArray(events) ? events : [events],
        };
        const body = {
            type: 'story',
            version: '2.2.0',
            origin,
            data: {
                username: document.cookie.replace(/(?:(?:^|.*;\s*)site.model.username\s*=\s*([^;]*).*$)|^.*$/, '$1') || null,
                ui_language: (document.documentElement && document.documentElement.lang) || null,
                location: window.location.href.toString(),
                referrer: referrer || document.referrer || null,
                version: '1.0.0',
                contexts: [finalContext],
            },
        };
        return sendPingback(body, options);
    };
}
